import type { User } from "@/lib/types";
import { isProfileCompleteForAccess } from "@/lib/profileCompletion";
import { sanitizeInternalPath } from "@/lib/navigation/authRedirect";
import { buildOnboardingNotificationsHref } from "@/lib/navigation/onboardingRedirect";

/** Next internal path after sign-in when profile and registration onboarding may be incomplete. */
export function resolvePostAuthDestination(
  user: User | null | undefined,
  redirectTo?: string | null,
): string {
  const safeRedirect = sanitizeInternalPath(redirectTo);

  if (!user) {
    return safeRedirect;
  }

  if (!isProfileCompleteForAccess(user)) {
    return `/complete-profile?email=${encodeURIComponent(user.email)}&redirectTo=${encodeURIComponent(safeRedirect)}`;
  }

  if (!user.registrationOnboardingCompletedAt) {
    return buildOnboardingNotificationsHref(safeRedirect);
  }

  return safeRedirect;
}
